class DataLayer {
  public push(hash: {}) {
    if (
      typeof window === 'undefined' ||
      // oxlint-disable-next-line typescript/no-explicit-any
      typeof (window as any).dataLayer === 'undefined'
    ) {
      // oxlint-disable-next-line typescript/no-explicit-any, no-console
      console.log(JSON.stringify(hash));
    } else {
      // oxlint-disable-next-line typescript/no-explicit-any
      (window as any).dataLayer.push(hash);
    }
  }
}

export const dataLayer = new DataLayer();
